<div class="dashboard--module-header">
  <div class="dashboard--module-main">
    <h2 class="subheading-sm">Issue history<button class="info-btn focus-element"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
  </div>
  <issues-history-chart class="block-chart"></issues-history-chart>
</div>



